import { render, staticRenderFns } from "./details.vue?vue&type=template&id=2eccb2a4&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=2eccb2a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eccb2a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eccb2a4')) {
      api.createRecord('2eccb2a4', component.options)
    } else {
      api.reload('2eccb2a4', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=2eccb2a4&scoped=true", function () {
      api.rerender('2eccb2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/indexes/list/components/details.vue"
export default component.exports